import React from 'react'; 
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  SidebarContainer,
  TopSection,
  LinkList,
  LinkItem,
  ActiveIndicator,
  LinkIcon,
  Logo,
  // CollapseButton,
  LogoutButton,
} from './MenuSideBar.styles';
import { useAuth } from '../../contexts/AuthContext';
import { Logout, } from '@mui/icons-material';


function SidebarLink({ imgBase, isActive, route, label, isCollapsed, dataTestId }) {
  const imgSrc = `/Icons/${imgBase}-${isActive ? 'active' : 'inactive'}.svg`;

  return (
    <LinkItem isActive={isActive} >
      {isActive && <ActiveIndicator />}
      <Link to={route} data-testid={dataTestId}>
        <LinkIcon src={imgSrc} alt={label} loading="lazy" />
        {!isCollapsed && <span>{label}</span>}
      </Link>
    </LinkItem>
  );
}

const MenuSideBar = () => {
  const location = useLocation();
  const { logout } = useAuth();
  const navigate = useNavigate();
  // const [isCollapsed, setIsCollapsed] = useState(false);

  // const toggleSidebar = () => {
  //   setIsCollapsed((prev) => !prev);
  // };

const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const sidebarLinks = [
    { id: 1, imgBase: "jigsaw-sidenav", route: "/dashboard", label: "Jigsaw Dashboard", dataTestId: "nav-link-1" },
    { id: 2, imgBase: "tender-process", route: "/tender-listing", label: "Tender Listing", dataTestId: "nav-link-2" },
  ];

  return (
    <SidebarContainer /*isCollapsed={isCollapsed}*/>
      <TopSection>
        <Logo data-testid="sidebar-logo" /*isCollapsed={isCollapsed}*/>
          <img src="/Icons/Jigsaw-Logo.png" alt="Jigsaw Logo" />
        </Logo>
        {/* <CollapseButton data-testid="sidebar-toggle" onClick={toggleSidebar}>
          <img src="/Icons/sidebar-collapse.svg" alt="Collapse Sidebar" />
        </CollapseButton> */}
      </TopSection>
      <LinkList>
        {sidebarLinks.map((link) => (
          <SidebarLink
            key={link.id}
            {...link}
            isActive={link.route === location.pathname}
            /*isCollapsed={isCollapsed}*/
          />
        ))}
      </LinkList>
      <LogoutButton onClick={handleLogout}>
        <Logout fontSize="small" />
          <span>Logout</span>
      </LogoutButton>
    </SidebarContainer>
  );
};

export default MenuSideBar;